import { useSelector } from '@app/hooks';

import { selectPermissions } from '../slice';

export const usePermissions = (role: 'employee' | 'company' | 'general') =>
  useSelector(selectPermissions, role);
